import React from "react";
import { Tag, Tooltip } from "antd";

const RentedStatus = () => {
    return (
        <Tag className={"pl-3 pr-3 pt-1 pb-1 font-bold"} color={"orange"}>
            <Tooltip title={"Rental Status"}>RENTED</Tooltip>
        </Tag>
    );
};
export default RentedStatus;
